<div class="comment-header">
	<i class="fas fa-dot-circle"></i>
	<label *ngIf="type === 'comment'" class="comment-date">Commented on {{item.created | date:'short'}}</label>
	<label *ngIf="type === 'stip'" class="comment-date">Stip on {{item.created | date:'short'}}</label>
</div>
<div class="comment-body">
	<i (click)="onDeleteItem(item)" *ngIf="activeActions" class="delete-comment fas fa-trash"></i>
	<p class="block-with-text" [ngClass]="{'block-with-text--more': viewMore}">{{text}}</p>

	<a href="javascript:void(0);" (click)="toggleViewMore()"
		*ngIf="isLargeItem && !viewMore">
		View more <i class="fas fa-chevron-down"></i>
	</a>

	<a href="javascript:void(0);" (click)="toggleViewMore()"
		*ngIf="isLargeItem && viewMore">
		Close <i class="fas fa-chevron-up"></i>
	</a>
</div>